import { EMPTY_ARRAY } from 'commons-ui';

import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.scheduledDowntime,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.scheduledDowntime].updateScheduledDowntime,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],

		bulkActions: EMPTY_ARRAY,

		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.scheduledDowntime,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.scheduledDowntime].addScheduledDowntime,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
